import {uniq} from "@pg-mono/nodash";

import {OFFER_3D_VIEWS, Offer3dView} from "../constants/offer_3d_views";

const offer3dViewIds = OFFER_3D_VIEWS.map((view) => view.id);

export type Offer3dViewIdSource =
    | {
          id?: number;
          group_primary_offer?: {id?: number} | null;
      }
    | null
    | undefined;

export const resolveOffer3dViewId = (offer: Offer3dViewIdSource): number | undefined => {
    //bcs of offer stages we need to check primary id first
    const primaryId = offer?.group_primary_offer?.id;
    if (primaryId != null) {
        return primaryId;
    }
    return offer?.id;
};

export const hasOffer3dView = (offer: Offer3dViewIdSource, apiConstructionTours?: Offer3dView[] | null): boolean => {
    if (apiConstructionTours && apiConstructionTours.length > 0) {
        return true;
    }
    const id = resolveOffer3dViewId(offer);
    return id != null && offer3dViewIds.includes(id);
};

export const getOffer3dViewLink = (
    offerId: number,
    stageId: number | undefined,
    month: string | null,
    apiConstructionTours?: Offer3dView[] | null
): string | undefined => {
    // API already returns tours scoped to this exact offer/stage - no need to fall back to stage/entry matching from the static file
    if (apiConstructionTours && apiConstructionTours.length > 0) {
        return month == null ? getLatestOffer3dView(apiConstructionTours)?.url : findOffer3dViewForMonth(apiConstructionTours, month)?.url;
    }

    const {stageViews, entryViews} = getOffer3dEntryViews(offerId, stageId);

    if (month == null) {
        return getLatestOffer3dView(stageViews)?.url ?? getLatestOffer3dView(entryViews)?.url;
    }

    return findOffer3dViewForMonth(stageViews, month)?.url ?? findOffer3dViewForMonth(entryViews, month)?.url;
};

export const getOffer3dViewMonths = (offerId: number, stageId?: number, apiConstructionTours?: Offer3dView[] | null): string[] => {
    if (apiConstructionTours && apiConstructionTours.length > 0) {
        return uniq(apiConstructionTours.map((view) => getOffer3dViewMonth(view.date)));
    }

    const {stageViews, entryViews} = getOffer3dEntryViews(offerId, stageId);
    return uniq([...stageViews, ...entryViews].map((view) => getOffer3dViewMonth(view.date)));
};

const parseOffer3dViewDate = (date: string): number => {
    return new Date(date).getTime();
};

const getOffer3dViewMonth = (date: string): string => {
    return date.slice(0, 7);
};

const getLatestOffer3dView = (views: Offer3dView[]): Offer3dView | undefined => {
    return [...views].sort((prev, next) => parseOffer3dViewDate(next.date) - parseOffer3dViewDate(prev.date))[0];
};

const findOffer3dViewForMonth = (views: Offer3dView[], month: string): Offer3dView | undefined => {
    return views.find((view) => getOffer3dViewMonth(view.date) === month);
};

const getOffer3dEntryViews = (offerId: number, stageId?: number): {stageViews: Offer3dView[]; entryViews: Offer3dView[]} => {
    const entry = OFFER_3D_VIEWS.find((view) => view.id === offerId);
    if (!entry) {
        return {stageViews: [], entryViews: []};
    }

    const stageLink = stageId ? entry.stageLinks?.find((sl) => sl.stageId === stageId) : undefined;
    return {stageViews: stageLink?.construction_3d_tours ?? [], entryViews: entry.construction_3d_tours};
};
import {uniq} from "@pg-mono/nodash";

import {OFFER_3D_VIEWS, Offer3dView} from "../constants/offer_3d_views";

const offer3dViewIds = OFFER_3D_VIEWS.map((view) => view.id);

export type Offer3dViewIdSource =
    | {
          id?: number;
          group_primary_offer?: {id?: number} | null;
      }
    | null
    | undefined;

export const resolveOffer3dViewId = (offer: Offer3dViewIdSource): number | undefined => {
    //bcs of offer stages we need to check primary id first
    const primaryId = offer?.group_primary_offer?.id;
    if (primaryId != null) {
        return primaryId;
    }
    return offer?.id;
};

export const hasOffer3dView = (offer: Offer3dViewIdSource, apiConstructionTours?: Offer3dView[] | null): boolean => {
    if (apiConstructionTours && apiConstructionTours.length > 0) {
        return true;
    }
    const id = resolveOffer3dViewId(offer);
    return id != null && offer3dViewIds.includes(id);
};

export const getOffer3dViewLink = (
    offerId: number,
    stageId: number | undefined,
    month: string | null,
    apiConstructionTours?: Offer3dView[] | null
): string | undefined => {
    // API already returns tours scoped to this exact offer/stage - no need to fall back to stage/entry matching from the static file
    if (apiConstructionTours && apiConstructionTours.length > 0) {
        return month == null ? getLatestOffer3dView(apiConstructionTours)?.url : findOffer3dViewForMonth(apiConstructionTours, month)?.url;
    }

    const {stageViews, entryViews} = getOffer3dEntryViews(offerId, stageId);

    if (month == null) {
        return getLatestOffer3dView(stageViews)?.url ?? getLatestOffer3dView(entryViews)?.url;
    }

    return findOffer3dViewForMonth(stageViews, month)?.url ?? findOffer3dViewForMonth(entryViews, month)?.url;
};

export const getOffer3dViewMonths = (offerId: number, stageId?: number, apiConstructionTours?: Offer3dView[] | null): string[] => {
    if (apiConstructionTours && apiConstructionTours.length > 0) {
        return uniq(apiConstructionTours.map((view) => getOffer3dViewMonth(view.date)));
    }

    const {stageViews, entryViews} = getOffer3dEntryViews(offerId, stageId);
    return uniq([...stageViews, ...entryViews].map((view) => getOffer3dViewMonth(view.date)));
};

const parseOffer3dViewDate = (date: string): number => {
    return new Date(date).getTime();
};

const getOffer3dViewMonth = (date: string): string => {
    return date.slice(0, 7);
};

const getLatestOffer3dView = (views: Offer3dView[]): Offer3dView | undefined => {
    return [...views].sort((prev, next) => parseOffer3dViewDate(next.date) - parseOffer3dViewDate(prev.date))[0];
};

const findOffer3dViewForMonth = (views: Offer3dView[], month: string): Offer3dView | undefined => {
    return views.find((view) => getOffer3dViewMonth(view.date) === month);
};

const getOffer3dEntryViews = (offerId: number, stageId?: number): {stageViews: Offer3dView[]; entryViews: Offer3dView[]} => {
    const entry = OFFER_3D_VIEWS.find((view) => view.id === offerId);
    if (!entry) {
        return {stageViews: [], entryViews: []};
    }

    const stageLink = stageId ? entry.stageLinks?.find((sl) => sl.stageId === stageId) : undefined;
    return {stageViews: stageLink?.construction_3d_tours ?? [], entryViews: entry.construction_3d_tours};
};
